import TagManager from "react-gtm-module";

import createDebug from "src/library/utils/debug";

import {
  GTMEventName,
  GTMEventType
} from "./gtm-types";

const debug = createDebug("GTM:EVENT");

/**
 * Send a google tag manager event
 *
 * @param eventName
 * @param eventParams
 */
export const gtmEvent = <D extends GTMEventName, CustomParams = unknown>(eventName: D, eventParams: GTMEventType<D, CustomParams>, user?: { user_id: string; user_type?: string; user_role?: string; }): void => {
  debug.log(`${eventName}  %o`, eventParams, user);
  // clear the ecommerce object before each event
  TagManager.dataLayer({ dataLayer: { ecommerce: null } });

  TagManager.dataLayer({
    dataLayer: {
      event: eventName,
      ...eventParams,
      ...(user || {})
    }
  });
};
